import clsx from 'clsx';

export function CheckboxCheckedIcon({ className }) {
  return (
    <svg
      className={clsx(className)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect width="20" height="20" rx="4" fill="currentColor" />
    </svg>
  );
}
